import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PagoWebPage } from '../pages/PagoWebPage';
import { ResponsePowerpayPage } from '../pages/ResponsePowerpayPage';

export const RouterApp = () => {
  return (
    <>
      <Routes>
        <Route path='/response_powerpay' element={<ResponsePowerpayPage />} />
        <Route path='/index.html' element={<PagoWebPage />} />
        <Route path='/' element={<PagoWebPage />} />        
        <Route path='/*' element={ <Navigate to='/' /> } />
      </Routes>
    </>
  )
}
